"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = ListRow;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var moment = require("moment");
var recompose_1 = require("recompose");
var formatSize_1 = require("utils/helpers/formatSize");
var isVisible_1 = require("utils/isVisible");
var react_router_dom_1 = require("react-router-dom");
var MobileButtons_1 = require("components/MobileButtons");
require("./style.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('selectedFileUuid', 'setSelectedFileUuid', undefined), (0, recompose_1.withState)('mobileButtons', 'setMobileButtons', false), react_router_dom_1.withRouter, recompose_1.pure);
var getAuthorName = function (attachments) {
    if (attachments.author) {
        return [attachments.author.firstName, attachments.author.lastName].join(' ');
    }
    return '';
};
var getAttachmentTableData = function (attachments) {
    return attachments.map(function (attachment) { return ({
        name: attachment.name,
        size: "".concat((attachment.meta &&
            attachment.meta.size &&
            (0, formatSize_1.formatSize)(attachment.meta.size)) ||
            0),
        created_at: "".concat((attachment.meta &&
            attachment.meta.created_at &&
            moment(parseInt(attachment.meta.created_at.toString(), 10)).format('l HH:mm')) ||
            ''),
        id: attachment.id,
        uuid: attachment.uuid,
        added_by: getAuthorName(attachment)
    }); });
};
function ListRow(props) {
    if (props.isMobile && props.viewportSize !== 'TABLET') {
        return (React.createElement(sok_ui_1.Table.Row, { className: "".concat(props.selectedFileUuid === props.row.uuid ? 'selected-mobile-row' : '') },
            React.createElement(sok_ui_1.Table.Column, null,
                React.createElement("span", { className: "fa-stack tablet-icons", onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        if (props.setMobileButtons) {
                            if (props.selectedFileUuid === props.row.uuid) {
                                props.setMobileButtons(!props.mobileButtons);
                                props.setSelectedFileUuid(undefined);
                            }
                            else {
                                props.setMobileButtons(true);
                                props.setSelectedFileUuid(props.row.uuid);
                            }
                        }
                    } },
                    React.createElement("i", { className: "fas fa-check-circle fa-stack-2x ".concat(props.selectedFileUuid === props.row.uuid
                            ? 'check-icon-selected'
                            : 'check-icon-unselected') }))),
            React.createElement(sok_ui_1.Table.Column, null,
                React.createElement("div", { className: "joblist-name-column", onClick: function (e) {
                        e.preventDefault();
                        props.setSelectedFileUuid(props.row.uuid);
                    } }, props.row.name)),
            React.createElement(sok_ui_1.Table.Column, null)));
    }
    return (React.createElement(sok_ui_1.Table.Row, { className: "attachments-list-row" },
        React.createElement(sok_ui_1.Table.Column, { className: "icon-column" },
            React.createElement("a", { className: "fa-stack tablet-icons", href: "".concat(__UPLOADSERVERURL__, "/files/").concat(props.row.uuid), target: "_blank" }, props.viewportSize === 'TABLET' ? (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "fal fa-square fa-stack-2x attachments-icon-black" }),
                React.createElement("i", { className: "fas fa-cloud-download fa-stack-1x fa-inverted" }))) : (React.createElement("i", { className: "fas fa-cloud-download fa-stack-1x attachments-icon-grey" })))),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement("a", { className: 'column-text', href: "".concat(__UPLOADSERVERURL__, "/files/").concat(props.row.uuid, "?preview=true"), target: "_blank" }, props.row.name)),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement("span", { className: 'column-text' }, props.row.size)),
        props.viewportSize !== 'TABLET' && (React.createElement(React.Fragment, null,
            React.createElement(sok_ui_1.Table.Column, null,
                React.createElement("span", { className: 'column-text' }, props.row.created_at)),
            React.createElement(sok_ui_1.Table.Column, null,
                React.createElement("span", { className: 'column-text' }, props.row.added_by)))),
        !props.isDisabled ? (React.createElement(sok_ui_1.Table.Column, { className: "icon-column justify-right" },
            React.createElement("span", { className: "fa-stack tablet-icons", onClick: function () { return props.handleOnDeleteClick(props.row.uuid); } }, props.viewportSize === 'TABLET' ? (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "fal fa-square fa-stack-2x attachments-icon-red" }),
                React.createElement("i", { className: "fas fa-times-circle fa-stack-1x attachments-icon-red" }))) : (React.createElement("i", { className: "fas fa-times-circle fa-stack-1x attachments-icon-red" }))))) : (React.createElement(sok_ui_1.Table.Column, null))));
}
exports.default = enhance(function (props) {
    var ref = React.useRef(null);
    var inViewport = (0, isVisible_1.isVisible)(ref, '0px');
    if (!inViewport && props.mobileButtons) {
        props.setMobileButtons(false);
        props.setSelectedFileUuid(undefined);
    }
    var attachmentTableData = getAttachmentTableData(props.attachments);
    var mobileButtonSettings = [
        {
            icon: 'fa fa-external-link',
            localization: 'worksitediary/attachments/open',
            onClick: function () {
                window.open("".concat(__UPLOADSERVERURL__, "/files/").concat(props.selectedFileUuid, "?preview=true"), '_blank');
                props.setMobileButtons(false);
                props.setSelectedFileUuid(undefined);
            }
        },
        {
            icon: 'fa fa-cloud-download',
            localization: 'worksitediary/attachments/download',
            onClick: function () {
                window.open("".concat(__UPLOADSERVERURL__, "/files/").concat(props.selectedFileUuid), '_blank');
                props.setMobileButtons(false);
                props.setSelectedFileUuid(undefined);
            }
        },
        {
            icon: 'fas fa-trash',
            localization: 'worksitediary/attachments/delete',
            onClick: function () {
                props.handleOnDeleteClick(props.selectedFileUuid);
                props.setMobileButtons(false);
                props.setSelectedFileUuid(undefined);
            }
        }
    ];
    return (React.createElement("div", { className: "workdiary-attachments", ref: ref },
        React.createElement(sok_ui_1.Panel, { title: (0, translation_1.getLocalization)('diaryEntryView/accordion/attachments') },
            React.createElement("div", { className: "upload-files-button-container" },
                React.createElement(sok_ui_1.Button, { className: "upload-files", icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }), color: 'base-green', text: (0, translation_1.getLocalization)('diaryEntryView/attachments/add'), size: "large", disabled: props.isDisabled, onClick: props.handleUpload })),
            props.attachmentsStatus === 'FETCHING' ||
                props.filesCrudStatus === 'SAVING' ? (React.createElement("div", null,
                React.createElement(sok_ui_1.LoadingSpinner, null))) : (attachmentTableData &&
                attachmentTableData.length > 0 && (React.createElement("div", { className: "workdiary-attachments-list-container" },
                React.createElement(sok_ui_1.Table.Table, { className: 'striped hovered' },
                    React.createElement(sok_ui_1.Table.Head, { className: "workdiary-attachments-list-header" },
                        React.createElement(sok_ui_1.Table.Row, null,
                            React.createElement(sok_ui_1.Table.Column, null),
                            React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)("diaryEntryView/attachments/name")),
                            props.viewportSize !== 'MOBILE' && (React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('diaryEntryView/attachments/size'))),
                            !props.isMobile && (React.createElement(React.Fragment, null,
                                React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('diaryEntryView/attachments/created_at')),
                                React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('diaryEntryView/attachments/added_by')))),
                            React.createElement(sok_ui_1.Table.Column, null))),
                    React.createElement(sok_ui_1.Table.Body, { className: "worksite-status-list-body" }, attachmentTableData &&
                        attachmentTableData.map(function (row, idx) { return (React.createElement(ListRow, { row: row, rowIndex: idx, key: "".concat(row.name, "-").concat(row.id, "-").concat(idx), mobileButtons: props.mobileButtons, setMobileButtons: props.setMobileButtons, isMobile: props.isMobile, isDisabled: props.isDisabled, selectedFileUuid: props.selectedFileUuid, viewportSize: props.viewportSize, handleOnDeleteClick: props.handleOnDeleteClick, setSelectedFileUuid: props.setSelectedFileUuid })); })))))),
            props.isMobile && props.mobileButtons && (React.createElement(MobileButtons_1.default, { className: "attachment-mobilebuttons", settings: mobileButtonSettings })))));
});
